import React, { Fragment } from "react";
import { Route, Routes } from "react-router-dom";

import { MainPageIndex } from "../pages/mainPages/MainPageIndex";
import { MainPagesAdvices } from "../pages/mainPages/MainPagesAdvices";
import { MainPagesCompany } from "../pages/mainPages/MainPagesCompany";
import { MainPagesContact } from "../pages/mainPages/MainPagesContact";
import { MainPagesServices } from "../pages/mainPages/MainPagesServices";
import { MainPageServicesRouter } from "./MainPagesServicesRouter";
import { MainPagesTeam } from "../pages/mainPages/MainPagesTeam";
export const MainPageRouter = () => {
  return (
    <Routes>
      <Route path="*" element={<MainPageIndex />} />
      <Route path="advices" element={<MainPagesAdvices />} />
      <Route path="services/*" element={<MainPageServicesRouter />} />
      <Route path="team" element={<MainPagesTeam />} />
      <Route path="company" element={<MainPagesCompany />} />
      <Route path="contact" element={<MainPagesContact />} />
    </Routes>
  );
};
